import React from 'react';
import styled from 'styled-components';

import { Button } from '../button';
import { IconFolderEmpty } from '../icon';
import { VerticalLayout } from '../Layout';
import { Text } from '../Text';

export const NotFoundTile = ({
    onClick,
    title,
    buttonText,
}: {
    title: string;
    buttonText?: string;
    onClick?: () => void;
}) => {
    return (
        <VerticalLayout $gap={16} $width="100%">
            <Tile $gap={16} $columnCenter>
                <IconFolderEmpty />
                <Text>{title}</Text>
            </Tile>
            {onClick ? (
                <Button buttonType="secondary" size="large" onClick={onClick}>
                    {buttonText}
                </Button>
            ) : null}
        </VerticalLayout>
    );
};

const Tile = styled(VerticalLayout)`
    padding: 2rem;
    border-radius: 3px;
    background-color: ${({ theme }) => theme.colors.cocoa100};
    width: 100%;
`;
